<div mat-dialog-content>
  <p *ngIf="labeledDataManager.modelType == 'text'">{{'labelcontainer.dialog.introducetext' | translate}}</p>
  <p *ngIf="labeledDataManager.modelType == 'numerical'">{{'labelcontainer.dialog.introducenumbers' | translate}}</p>

  <mat-form-field>
    <input matInput cdkFocusInitial [(ngModel)]="data">
  </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial>{{'model.confirm.ok' | translate}}</button>
    <button mat-button (click)="onNoClick()">{{ 'model.confirm.cancel' | translate }}</button>
</div>